module.exports = __webpack_public_path__ + "assets/img/053.bd0dc570.png";